import { useEffect, useState } from "react";

export function TaskDisclosure({
  actionLabel = "Open",
  children,
  closeLabel = "Close",
  defaultOpen = false,
  description,
  title
}) {
  const [isOpen, setIsOpen] = useState(Boolean(defaultOpen));

  useEffect(() => {
    if (defaultOpen) {
      setIsOpen(true);
    }
  }, [defaultOpen]);

  return (
    <details
      className="task-disclosure"
      open={isOpen}
      onToggle={(event) => setIsOpen(event.currentTarget.open)}
    >
      <summary>
        <span className="task-disclosure-copy">
          <strong>{title}</strong>
          {description && <span>{description}</span>}
        </span>
        <span className="task-disclosure-action" role="button" aria-label={`${isOpen ? closeLabel : actionLabel}: ${title}`}>
          {isOpen ? closeLabel : actionLabel}
        </span>
      </summary>
      <div className="task-disclosure-body">
        {children}
      </div>
    </details>
  );
}
